import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Plus_xs = (props) => {
    const width = props.width ? props.width + 'px' : '16px';
    const height = props.height ? props.height + 'px' : '16px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 16 16"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1.75C8.41421 1.75 8.75 2.08579 8.75 2.5V7.25H13.5C13.9142 7.25 14.25 7.58579 14.25 8C14.25 8.41421 13.9142 8.75 13.5 8.75H8.75V13.5C8.75 13.9142 8.41421 14.25 8 14.25C7.58579 14.25 7.25 13.9142 7.25 13.5V8.75H2.5C2.08579 8.75 1.75 8.41421 1.75 8C1.75 7.58579 2.08579 7.25 2.5 7.25H7.25V2.5C7.25 2.08579 7.58579 1.75 8 1.75Z"
            />
        </SvgStyled>
    );
};

export default Plus_xs;
